class HeliosCarousel extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.slider = this.querySelector('.helios-swiper');
        this.slides = [...this.querySelectorAll('.swiper-slide')];
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');

        if (!this.slider || !this.slides.length) return;

        this.variant = this.dataset.variant || 'responsive';

        if (this.variant === 'responsive') {
            this.mediaQuery = window.matchMedia('(max-width: 1023px)');
            this.onMediaChange = this.onMediaChange.bind(this);
            this.toggleSwiper();
            this.mediaQuery.addEventListener('change', this.onMediaChange);
        } else if (this.variant == 'full') {
            this.initSwiper();
        }
    }

    disconnectedCallback() {
        this.destroySwiper();
        this.mediaQuery?.removeEventListener('change', this.onMediaChange);
    }

    toggleSwiper() {
        if (this.mediaQuery.matches) {
            this.initSwiper();
        } else {
            this.destroySwiper();
        }
    }

    getSwiperOptions() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const base = {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            watchOverflow: true,
            speed: reduceMotion ? 0 : 300,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
            },
            a11y: {
                enabled: true,
            },
        };

        if (this.variant === 'full') {
            return {
                ...base,
                loop: true,
                breakpoints: {
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 3.5 },
                },
            };
        }

            return base;
    }

        initSwiper() {
            if (this.swiper) return;

            const options = this.getSwiperOptions();

            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.prevButton.hidden = false;
            this.nextButton.hidden = false;

            this.swiper = new Swiper(this.slider, options);
        }

        destroySwiper() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            if (this.prevButton) {
                this.prevButton.hidden = true;
            }
            if (this.nextButton) {
                this.nextButton.hidden = true;
            }
        }

        onMediaChange() {
            this.toggleSwiper();
        }
    }

    if(!customElements.get('helios-carousel')) {
    customElements.define(
        'helios-carousel',
        HeliosCarousel
    );
}